export default "__VITE_ASSET__Du5tA5c5__"